export default __webpack_public_path__ + "static/pimg4-d9b5bb4d86c5022753212f45ff96919e.jpg";